import { ComponentFactoryResolver, Injectable, Injector, TemplateRef } from '@angular/core';
import { ModalStackService } from './modal-stack.service';
import { ModalOptions } from '../interfaces/options.interface';
import { ModalRef } from '../classes/modal-ref';

@Injectable()
export class ModalService {

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector, private stack: ModalStackService) {
    }

    /**
     * Open a new modal with the given component or template ref.
     *
     * @param content
     * @param data
     * @param {ModalOptions} options
     * @return {ModalRef}
     */
    public open(content: any | TemplateRef<any>, data: { [key: string]: any } = {}, options: ModalOptions = {}): ModalRef {
        options.classes  = options.classes || 'slide-right';
        options.backdrop = options.backdrop !== undefined ? options.backdrop : 'static';

        return this.stack.open(this.componentFactoryResolver, this.injector, content, data, options);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/services/modal.service.ts